module.exports = __webpack_public_path__ + "static/img/qi_4.94fc21e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qi_4.jpg
// module id = qo8Q
// module chunks = 1